import {ReactComponent as Loader} from "@assets/svg/loader.svg";

export default function CustomLoader () {
     console.trace("CUSTOM LOADER TRACE");

return <div className="h-screen w-screen  top-0 left-0 shrink-0 d-flex flex-col align-items-center justify-center fixed md:static bg-sec">
          <Loader height={20} width={20}/>
      </div>
}
